export default __webpack_public_path__ + "static/media/telephone.23165624.svg";